// external modules
import { useRecoilValue } from "recoil";
// state
import { introStepState } from "store/recoil/@intro/introState";
// styles & types & assets
import styles from "./StepIndicator.module.scss";

export default function StepIndicator() {
  const introStep = useRecoilValue(introStepState);
  return (
    <section className={styles["wrapper-indicator"]}>
      <span className={`${styles["circle"]} ${introStep === 1 && styles["selected"]}`} />
      <span className={`${styles["circle"]} ${introStep === 2 && styles["selected"]}`} />
      <span className={`${styles["circle"]} ${introStep === 3 && styles["selected"]}`} />
      <span className={`${styles["circle"]} ${introStep === 4 && styles["selected"]}`} />
      <span className={`${styles["circle"]} ${introStep === 5 && styles["selected"]}`} />
    </section>
  );
}
